import { useEffect, useState } from 'react'

/** Long enough to swallow a burst of typing, short enough that the list feels
 *  like it is keeping up. Shared so every search on the estate waits the same. */
export const DEBOUNCE_MS = 250

/**
 * The value, settled.
 *
 * Every search here is a server round trip against patient data, and one
 * request per keystroke both races itself — a slow answer for "9876" landing
 * after a fresh one for "98765" — and hammers an audited endpoint.
 */
export function useDebounced<T>(value: T, delay = DEBOUNCE_MS): T {
  const [debounced, setDebounced] = useState(value)
  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), delay)
    return () => window.clearTimeout(timer)
  }, [value, delay])
  return debounced
}
